import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" fill="none"><path d="M5.382.67L.628 5.942l4.754 5.353" stroke="currentcolor" stroke-linecap="square"/></svg>`;

export { symbol as default };
